import {i18n} from '@/plugins/i18n'

export const walletSettlementTransferType = {
    Direct: 1,
    Queued: 2,
};

export const walletSettlementTransferTypeStr = {
    Direct: i18n.t('wallets.label.direct'),
    Queued: i18n.t('wallets.label.queued'),

    get(type) {
        let type_str = null;

        Object.keys(walletSettlementTransferType).forEach(item => {
            if (walletSettlementTransferType[item] === type) {
                type_str = walletSettlementTransferTypeStr[item];
            }
        });

        return type_str;
    }
};
